import script from "./ParaQuem.vue?vue&type=script&setup=true&lang=js"
export * from "./ParaQuem.vue?vue&type=script&setup=true&lang=js"

import "./ParaQuem.vue?vue&type=style&index=0&id=a29bb46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a29bb46a"]])

export default __exports__